/* eslint-disable import/first */

import router from 'girder/router';
import events from 'girder/events';
import { exposePluginConfig } from 'girder/utilities/PluginUtils';

exposePluginConfig('homepage', 'plugins/homepage/config');

import ConfigView from './views/ConfigView';
router.route('plugins/homepage/config', 'homepageConfig', function () {
    events.trigger('g:navigateTo', ConfigView);
});



// WEBPACK FOOTER //
// ./plugins/homepage/web_client/routes.js